import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { ProofStrip } from './components/sections/ProofStrip';
import { Problem } from './components/sections/Problem';
import { Introducing } from './components/sections/Introducing';
import { Systems } from './components/sections/Systems';
import { Bonuses } from './components/sections/Bonuses';
import { ValueStack } from './components/sections/ValueStack';
import { Guarantee } from './components/sections/Guarantee';
import { Author } from './components/sections/Author';
import { Testimonials } from './components/sections/Testimonials';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full min-h-full bg-ink-950 font-sans text-white antialiased" data-id="element-0" data-mp="23v2td3l0915e">
      <MetaPixel data-id="element-1" data-mp="3ijfw82xf22g7" />
      <Hero data-id="element-2" data-mp="3ihv2ugmu8pjx" />
      <main data-id="element-3" data-mp="3ii4q3wgi0ilx">
        <ProofStrip data-id="element-4" data-mp="3mlavz2zp87rv" />
        <Problem data-id="element-5" data-mp="3mkrchhuehbbq" />
        <Introducing data-id="element-6" data-mp="3mk84asujy1aw" />
        <Systems data-id="element-7" data-mp="3mjg9vlcoy9m7" />
        <Bonuses data-id="element-8" data-mp="3rc9em985thya" />
        <ValueStack data-id="element-9" data-mp="3rbr9en3irte8" />
        <Guarantee data-id="element-10" data-mp="3rdaq2et386gj" />
        <Author data-id="element-11" data-mp="3rcswjpxt86cb" />
        <Testimonials data-id="element-12" data-mp="3recd7hndojem" />
        <Faq data-id="element-13" data-mp="5ygolyg4xb6" />
        <FinalCta data-id="element-14" data-mp="6hovayao7c0" />
      </main>
      <Footer data-id="element-15" data-mp="4n7g6m8exco" />
      <PurchasePopup data-id="element-16" data-mp="56m9egl55mh" />
      <FloatingCta data-id="element-17" data-mp="7sxpp6lk59z" />
    </div>;
}